import { MdFolder } from 'react-icons/md';
import { generatePath, Link } from 'react-router-dom';
import { Icon } from '@nbirl/nbi-common-ui-libs';

import { PATHS } from '../../../../../shared/constants';
import { DocumentListRow } from '../../models';
import { FileExtensionIcon } from '../file-extension-icon.component';

type DocumentsListNameCellProps = {
  row: Pick<DocumentListRow, 'path' | 'extension' | 'isFolder' | 'id'>;
  value: string;
  isSearching: boolean;
};

export const DocumentListNameCell: React.FC<DocumentsListNameCellProps> = ({
  row,
  value,
  isSearching,
}) => (
  <div
    className="flex items-center space-x-2"
    data-tip={isSearching ? row.path : undefined}
  >
    {row.extension ? (
      <FileExtensionIcon
        extension={row.extension}
        className="flex-none text-gray-200 flex-shrink-0"
      />
    ) : (
      <Icon icon={<MdFolder className="text-gray-200 flex-shrink-0" />} />
    )}
    {row.isFolder ? (
      <Link
        to={generatePath(PATHS.Documents, {
          folderId: row.id,
        })}
        className="hover:underline auto-table-break-words"
      >
        {value}
      </Link>
    ) : (
      <div className="auto-table-break-words">{value}</div>
    )}
  </div>
);
